import "./style.scss";
import * as React from "react";
import { Button as AntDButton } from "antd";

class Button extends React.Component<any, any> {
  render() {
    return <AntDButton {...this.props}></AntDButton>;
  }
}

export default Button;



// WEBPACK FOOTER //
// ./client/modules/core/Button/index.tsx